import {SpineButton} from '@fantasmagames/core/src/display/SpineButton';
import {View} from '@fantasmagames/slot/src/common/view/View';
import {BetButtonViewEvents} from '@fantasmagames/slot/src/modules/keypad/bet/BetButtonViewEvents';
import {Position} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import 'pixi.js';

export class BetButtonView extends View {
	protected _betButton: SpineButton;

	public init(): void {
		super.init();

		this._betButton = this.spineUtils.createSpineButton('BET_BUTTON.json', this.onBetButtonClicked.bind(this));
		const betButtonPosition: Position = this.layout.getAbsolutePosition('BET_BUTTON');
		this._betButton.position.set(betButtonPosition.x, betButtonPosition.y);
		this.container.addChild(this._betButton);
	}

	public enableBetButton(): void {
		this._betButton.enable();
		// this._betButton.visible = true;
	}

	public disableBetButton(): void {
		this._betButton.disable();
	}

	public hideBetButton(): void {
		this._betButton.visible = false;
	}

	public showBetButton(): void {
		this._betButton.visible = true;
	}

	protected onBetButtonClicked(): void {
		this.soundPlayer.play('buttonClick');
		this.emit(BetButtonViewEvents.BET_BUTTON_CLICKED);
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/keypad/bet/BetButtonView.ts